import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import QuestionCard from './QuestionCard';

/**
 * Draggable wrapper for QuestionCard
 */
const DraggableQuestionCard = ({ 
  question, 
  index, 
  totalQuestions, 
  onExport, 
  isCustomizeMode,
  sectionId 
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: `${sectionId}-${question.fieldId}`,
    data: {
      type: 'question',
      question,
      sectionId
    }
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (!isCustomizeMode) {
    // Regular mode - just render the QuestionCard
    return (
      <QuestionCard
        question={question}
        index={index}
        totalQuestions={totalQuestions}
        onExport={onExport}
      />
    );
  }

  // Customize mode - render with drag handle
  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative ${isDragging ? 'opacity-50' : ''}`}
      {...attributes}
    >
      {/* Drag handle */}
      <div
        {...listeners}
        className="absolute left-2 top-4 z-10 cursor-grab active:cursor-grabbing p-1 hover:bg-muted rounded opacity-50 hover:opacity-100 transition-opacity"
        title="Drag to reorder"
      >
        <GripVertical className="h-4 w-4 text-muted-foreground" />
      </div>
      
      {/* Question card with left padding for drag handle */}
      <div className="pl-8">
        <QuestionCard
          question={question}
          index={index}
          totalQuestions={totalQuestions}
          onExport={onExport}
        />
      </div>
    </div>
  );
};

export default DraggableQuestionCard;